module.exports = {"future":"%s restantes","past":"%s atrás","s":"en unos segundos","ss":"%d segundos","m":"un minuto","mm":"%d minutos","h":"una hora","hh":"%d horas","d":"un día","dd":"%d días","M":"un mes","MM":"%d meses","y":"un año","yy":"%d años"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/moment.es.json
// module id = 669
// module chunks = 1 2